import { Dialog, Grid, DialogTitle, Typography, DialogContent } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {getLanguage } from "@utils/changeLanguage";
interface IParams {
    provider: string;
    isModalOpen: boolean;
    close(): void;
}

const PortabilityInfoModal = (props: IParams) => {
    const { t } = useTranslation("portin");
    const { provider, isModalOpen, close } = props;
    var lang = getLanguage();

    return (
        <>
            <Dialog fullWidth maxWidth="md" open={isModalOpen} onClose={close}>
                <Grid className="dialog-close" container justify="flex-end">
                    <Grid className="dialog-close__icon" item>
                        <IconButton aria-label="close" onClick={close}>
                            <CloseIcon style={{ color: "#ffffff" }} />
                        </IconButton>
                    </Grid>
                </Grid>
                <DialogTitle disableTypography style={{ backgroundColor: "#4a148c" }}>
                    <Grid container justify="center">
                        <Grid item xs={12}>
                            <Typography align="center" style={{ color: "#ffffff" }} variant="h3">
                                {t("findPortabilityCode")}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{ padding: "10px" }}>
                    {provider === "CP" && <img alt="CYTA" style={{ width: "100%", height: "100%" }} src={`https://gomo.cy/wp-content/uploads/cyta_portin_${lang}.png`} />}
                    {provider === "PR" && (
                        <img alt="PRIMETEL" style={{ width: "100%", height: "100%" }} src={`https://gomo.cy/wp-content/uploads/primetel_portin_${lang}.png`} />
                    )}
                    {provider === "CN" && (
                        <img alt="CABLENET" style={{ width: "100%", height: "100%" }} src={`https://gomo.cy/wp-content/uploads/cablenet_portin_${lang}.png`} />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default PortabilityInfoModal;
